import { useFiltersStore } from '../context';

export const useGetBookingType = () => {
  const service = useFiltersStore((state) => state.filters.service);
  return (
    {
      isWalkOrDropIn: service === 'walk' || service === 'drop-in' 
    }
  )
};